import { render, staticRenderFns } from "./Orangebutton.vue?vue&type=template&id=165989a6&"
import script from "./Orangebutton.vue?vue&type=script&lang=js&"
export * from "./Orangebutton.vue?vue&type=script&lang=js&"
import style0 from "./Orangebutton.vue?vue&type=style&index=0&id=165989a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports